// Routes. De standaardpagina hangt af van de rol: de planner begint op Planning, de medewerker op Mijn werk.
import { Navigate, Route, Routes } from "react-router";
import { useMe } from "./lib/hooks";
import { useSettings } from "./lib/settings";
import { Bord } from "./screens/Bord";
import { Capaciteit } from "./screens/Capaciteit";
import { Instellingen } from "./screens/Instellingen";
import { Klantprojecten } from "./screens/Klantprojecten";
import { Koppelingen } from "./screens/Koppelingen";
import { MijnWerk } from "./screens/MijnWerk";
import { Opschonen } from "./screens/Opschonen";
import { Support } from "./screens/Support";
import { Taak } from "./screens/Taak";
import { Taken } from "./screens/Taken";
import { Teams } from "./screens/Teams";
import { Tijdlijn } from "./screens/Tijdlijn";
import { Layout } from "./shell/Layout";

/** Startpagina per rol; de schil toont dit pas als bekend is wie aangemeld is. */
function Start() {
  const { data: me } = useMe();
  return <Navigate to={me?.role === "planner" ? "/planning" : "/mijn-werk"} replace />;
}

export function App() {
  useSettings(); // Instellingen: drempels en labelbetekenis gelden op elk scherm
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Start />} />
        <Route path="planning" element={<Bord />} />
        <Route path="planning/tijdlijn" element={<Tijdlijn />} />
        <Route path="planning/capaciteit" element={<Capaciteit />} />
        <Route path="mijn-werk" element={<MijnWerk />} />
        <Route path="taken" element={<Taken />} />
        <Route path="taken/:id" element={<Taak />} />
        <Route path="opschonen" element={<Opschonen />} />
        <Route path="klantprojecten" element={<Klantprojecten />} />
        <Route path="support" element={<Support />} />
        <Route path="teams" element={<Teams />} />
        <Route path="koppelingen" element={<Koppelingen />} />
        <Route path="instellingen" element={<Instellingen />} />
        <Route path="*" element={<Navigate to="/planning" replace />} />
      </Route>
    </Routes>
  );
}
